export const getAngleByTime = (timeStr) => {
  // Split the time and convert hours and minutes to numbers
  const [hours, minutes] = timeStr && timeStr.split(":").map(Number);

  // Validate that hours and minutes are valid numbers
  if (
    isNaN(hours) ||
    isNaN(minutes) ||
    hours < 0 ||
    hours >= 24 ||
    minutes < 0 ||
    minutes >= 60
  ) {
    throw new Error("Invalid time format");
  }
  // Adjust for 12-hour clock format
  const adjustedHours = hours % 12; // Use modulus to get 12-hour format
  const totalMinutes = adjustedHours * 60 + minutes;

  // Calculate the angle: (total minutes / total minutes in 12 hours) * 360 degrees
  const angle = (totalMinutes / (12 * 60)) * 360;

  return angle;
};
